import { css, getAppStore } from 'jimu-core';
export const resizableStyles = (props) => {
    const theme = props.theme;
    const gray700 = theme === null || theme === void 0 ? void 0 : theme.ref.palette.neutral[1000];
    const white = theme === null || theme === void 0 ? void 0 : theme.ref.palette.white;
    const isRTL = getAppStore().getState().appContext.isRTL;
    const scaleX = isRTL ? ' scaleX(-1);' : '';
    const borderX = isRTL ? `border-left: 3px solid  ${gray700};` : `border-right: 3px solid  ${gray700};`;
    return css `
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: ${white};
    border: 1px solid transparent;
    .resizer{
      position: absolute;
      display: flex;
      z-index: 999;
      &.resizer-default {
        width: 10px;
        height: 10px;
        ${borderX}
        border-bottom: 3px solid  ${gray700};
      }
      &.top-left {
        left: 0px;
        top: 0px;
        cursor: ${isRTL ? 'nesw-resize' : 'nwse-resize'};
        transform: rotate(180deg)${scaleX};
      }
      &.top-right {
        top: 0px;
        right: 0px;
        cursor: ${isRTL ? 'nwse-resize' : 'nesw-resize'};
        transform: ${isRTL ? 'rotate(90deg)' : 'rotate(270deg)'}${scaleX};
      }
      &.bottom-left {
        left: 0px;
        bottom: 0px;
        cursor: ${isRTL ? 'nwse-resize' : 'nesw-resize'};
        transform: ${isRTL ? 'rotate(270deg)' : 'rotate(90deg)'}${scaleX};
      }
      &.bottom-right {
        right: 0px;
        bottom: 0px;
        cursor: ${isRTL ? 'nesw-resize' : 'nwse-resize'};
        transform: rotate(0deg)${scaleX};
      }
    }
  `;
};
